import React, { ReactNode } from 'react';
import { PlacesType, Tooltip } from 'react-tooltip';
import { v4 as uuidv4 } from 'uuid';
import { SUPER_HIGH_Z_INDEX } from '../tours/constants';

interface TooltipWrapperProps {
    children: ReactNode;
    content: string | undefined;
    place?: PlacesType;
    id?: string;    
    className?: string;
    tooltipClassName?: string;
    showTooltip?: boolean;
}

const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
    children,
    content,
    place = 'top',
    id,
    className,
    tooltipClassName = "",
    showTooltip = true,
}) => {
    const tooltipId = id || `tooltip-${uuidv4().substring(0, 6)}`;
    
    return (
        <div className={className}>
            <div data-tooltip-id={tooltipId}>
                {children}
            </div>
            {showTooltip && <Tooltip 
                id={tooltipId} 
                place={place}
                content={content}
                className={`!opacity-100 ${SUPER_HIGH_Z_INDEX} ${tooltipClassName}`}
            />}
        </div>
    );
};

export default TooltipWrapper;
